import React, { useRef } from "react";
import { RotateCcw } from "lucide-react";

const SignatureCanvas = React.forwardRef(({ onDraw }, ref) => {
  const drawing = useRef(false);
  const pos = (e) => {
    const c = ref.current; const r = c.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: (t.clientX - r.left) * (c.width / r.width), y: (t.clientY - r.top) * (c.height / r.height) };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext("2d"); const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ref.current.getContext("2d"); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.strokeStyle = "#111"; ctx.lineWidth = 2.5; ctx.lineCap = "round"; ctx.stroke(); onDraw && onDraw(true); };
  const end = () => { drawing.current = false; };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); onDraw && onDraw(false); };
  return (
    <div>
      <canvas ref={ref} width={500} height={170}
        className="w-full h-40 bg-white border border-neutral-300 rounded-lg touch-none" data-testid="signature-canvas"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
      <button type="button" onClick={clear} className="mt-1.5 text-xs text-neutral-500 hover:text-brand flex items-center gap-1"><RotateCcw size={12} /> Effacer</button>
    </div>
  );
});

export default SignatureCanvas;
